var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "ma-n1",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "width": "150",
      "color": _vm.form.interview.isOnline == true ? 'primary' : 'grey-d'
    },
    on: {
      "click": function ($event) {
        return _vm.emit(true);
      }
    }
  }, [_c('span', {
    class: {
      'grey--text': _vm.form.interview.isOnline != true
    }
  }, [_vm._v(" 온라인 ")])])], 1), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "width": "150",
      "color": _vm.form.interview.isOnline != true ? 'primary' : 'grey-d'
    },
    on: {
      "click": function ($event) {
        return _vm.emit(false);
      }
    }
  }, [_c('span', {
    class: {
      'grey--text': _vm.form.interview.isOnline == true
    }
  }, [_vm._v(" 오프라인 ")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }